"use strict";

// Show loginCtn when confirmBtn is clicked
$(document).on("click", "#confirm", function () {
    $(".modalBody").hide();
    $(".loginCtn").show();
});

// Hide backgroundCtn on cancelBtn or crossBtn click
$(document).on("click", "#cancel, #cross", function () {
    $(".backgroundCtn").toggleClass('d-none');
    $(".modalBody").show();
    $(".loginCtn").hide();
});